import { VideoPoster } from "../models/videoposter";

export class Content{

    portalURL: string;
    editorID: number;
    status: boolean;
    message: string;
    portal: any;
    hasGuest: boolean;
    hasUsers: boolean;
    username: string;
    password: string;
    imageData: string;
    startDate: string;
    endDate: string;
    players: number[];
    allPlayers: boolean;
    submissionID: string;
    width: number;
    height: number;
    directorID: number;
    superUser: boolean;
    superUsername: string;
    clientCode: number;
    videoPoster: VideoPoster;
    noPlayersToAssign: boolean;
    constructor(){

    }

    resetToLogin(){
        this.username = null;
        this.password = null;
        this.status = null;
        this.message = null;
        this.editorID = null;
        this.imageData = null;
        this.startDate = null;
        this.endDate = null;
        this.players = [];
        this.allPlayers = false;
        this.submissionID = null;
        this.width = null;
        this.height = null;
        this.videoPoster = null;
    }

    resetToCreate(){
        this.imageData = null;
        this.startDate = null;
        this.endDate = null;
        this.players = [];
        this.allPlayers = false;
        this.submissionID = null;
        this.width = null;
        this.height = null;
        this.videoPoster = null;
    }

    setImageData(i: string){
        this.imageData = i;
    }
    setStartDate(sd: string){
        this.startDate = sd;
    }
    setEndDate(ed: string){
        this.endDate = ed;
    }
    addPlayer(p: number){
        if(!this.players) this.players = [];
        this.players.push(p);
    }
    setAllPlayers(f: boolean){
        this.allPlayers = f;
    }
    setSubmissionID(sid: string){
        this.submissionID = sid;
    }

    setDirectorID(did: number){
        this.directorID = did;
    }
    setSuperUser(su: boolean){
        this.superUser = su;
    }
    setSupeUsername(sun: string){
        this.superUsername = sun;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/content.ts